import { Flex, Text, type TextProps } from '@/ui';

type TextAreaCharacterCountProps = {
  value: number;
  maxLength?: number;
} & TextProps;

export const TextAreaCharacterCount = ({
  value,
  maxLength = 500,
  ...props
}: TextAreaCharacterCountProps) => {
  return (
    <Flex justifyContent="flex-end" w="100%">
      <Text
        color={value >= maxLength ? 'red.500' : 'gray.500'}
        fontSize="xs"
        {...props}
      >
        {value}/{maxLength}
      </Text>
    </Flex>
  );
};
